import { app } from "@microsoft/teams-js";
import React, { createContext, useContext } from "react";

import { TeamsLoader } from "../components/TeamsLoader";
import { AGILE_STATIC_TABS, SURVEY_STATIC_TABS } from "../constants/StaticTabEnum";

type ApplicationState = {
  teamsContext: app.Context;
  hostTab?: string;
};

type ComponentProps = {
  teamsContext?: app.Context;
};

const DEFAULT_APP_STATE = {
  teamsContext: null as any,
};

const TeamsContext = createContext<ApplicationState>(DEFAULT_APP_STATE);

export const TeamsContextProvider: React.FC<ComponentProps> = ({ teamsContext, children }) => {
  return (
    <TeamsLoader isLoading={!teamsContext} loadingMessage="Loading teams information...">
      {teamsContext && (
        <TeamsContext.Provider
          value={{
            teamsContext,
            hostTab: getHostTab(teamsContext.page.id),
          }}
        >
          {children}
        </TeamsContext.Provider>
      )}
    </TeamsLoader>
  );
};
export const useTeamsContext = () => useContext(TeamsContext);

const getHostTab = (entityId?: string) => {
  if (entityId === AGILE_STATIC_TABS.DASHBOARD || entityId === SURVEY_STATIC_TABS.DASHBOARD) {
    return "dashboard";
  }
  return;
};
